import { messageHttpFailure } from "./http-message.ts";
import { Schema } from "effect";

export const ResourceRequestError = /* @__PURE__ */ (() => {
  class ResourceRequestError extends Schema.TaggedError<ResourceRequestError>()("ResourceRequestError", {
    message: Schema.String, status: Schema.Literals([400, 404, 409]), available: Schema.optionalKey(Schema.Array(Schema.String))
  }) {}
  return ResourceRequestError;
})();
export type ResourceRequestError = InstanceType<typeof ResourceRequestError>;
export const ResourceStorageError = /* @__PURE__ */ (() => class ResourceStorageError extends messageHttpFailure<ResourceStorageError>()("ResourceStorageError", 500) {})();
export type ResourceStorageError = InstanceType<typeof ResourceStorageError>;
export type ResourceFailure = ResourceRequestError | ResourceStorageError;
export const resourceInvalid = (message: string) => new ResourceRequestError({ message, status: 400 });
export const resourceMissing = (message = "Not found.", available?: readonly string[]) =>
  new ResourceRequestError({ message, status: 404, ...(available === undefined ? {} : { available }) });
export const resourceConflict = (message: string) => new ResourceRequestError({ message, status: 409 });
export const resourceUnavailable = () => new ResourceStorageError({ message: "Resource storage is unavailable." });
